<div class="margin-top-30">
  <div class="container container-lg">
    <div class="border-div property-details-box">
      <h2 class="mainhead">
        <span class="text">
          {{property.PropertyName}}
        </span>
      </h2>
      <h2 class="subhead margin-top-20">
        <span class="text">
          {{property.FullAddress && (property.FullAddress.length > 5) ? property.FullAddress:''}}
        </span>
      </h2>
      <sub class="pro-id" *ngIf="property.LiveSequenceId!=null&&property.LiveSequenceId!=''">#{{property.LiveSequenceId}}</sub>
      <br />
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Property Type</label>
            <h6 class="displayvalue" tooltip="{{property.AssetType}}">{{property.AssetType}}</h6>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Subcategory</label>
            <h6 class="displayvalue" tooltip="{{property.Subcategory}}">{{property.Subcategory ? property.Subcategory : '-'}}</h6>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Rating</label>
            <h6 class="displayvalue">{{property.Rating?property.Rating:'-'}}</h6>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Lease Structure</label>
            <h6 class="displayvalue">{{property.LeaseStructure}}</h6>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Net Operating Income</label>
            <h6 class="displayvalue">
              {{property.NetOperatingIncome && property.NetOperatingIncome !== 0 ? '$' + (property.NetOperatingIncome | number:0) : '-'}}
            </h6>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Remaining Term</label>
            <h6 class="displayvalue">
              {{property.Remaining_Term ? (property.Remaining_Term) :'-'}}
            </h6>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Guarantor</label>
            <h6 class="displayvalue">{{property.Guarantor ? property.Guarantor : '-'}}</h6>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Rent Escalations</label>
            <h6 class="displayvalue">{{property.RentEscalations}}</h6>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Year Built</label>
            <h6 class="displayvalue">
              {{property.YearBuilt ? property.YearBuilt  : '-'}}
            </h6>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Building Size</label>
            <h6 class="displayvalue">
              {{property.BuildingSize && property.BuildingSize != 0 ? (property.BuildingSize | number) + ' SF' : '-'}}
            </h6>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Land</label>
            <h6 class="displayvalue">{{property.Land && property.Land != 0 ? (property.Land | number :'1.2-2') + ' AC' : '-'}}</h6>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="blocklabel">Ownership Type</label>
            <h6 class="displayvalue">
              {{property.OwnershipType ? property.OwnershipType  : '-'}}
            </h6>
          </div>
        </div>
        <!--<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
      <div class="form-group">
        <label class="blocklabel">Property Characteristics</label>
        <h6 class="displayvalue">{{characterstics ? characterstics:'-'}}</h6>
      </div>
    </div>-->
      </div>
      <!--<div class="row">-->
      <!--<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="blocklabel">Options</label>
              <h6 class="displayvalue">
                {{
  (property.Options ? property.Options : '') +(property.OptionLength && property.Options ? ', ' : '') +
                                              (property.OptionLength ? property.OptionLength + ' ' : '') +
                                              (property.OptionLength ? '-' : '') +
                                              (property.OptionLength ? (property.OptionLength > 1 ? ' Year(s)' : ' Year(s)') : '')
                }}
              </h6>
            </div>
          </div>-->
      <!--<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
      <div class="form-group">
        <label class="blocklabel">Ownership Type</label>
        <h6 class="displayvalue">
          {{property.OwnershipType ? property.OwnershipType  : '-'}}
        </h6>
      </div>
    </div>
  </div>-->
    </div>
 
    </div>
  </div>
